import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { InputVistaInformacionGeneral, OutputVistaInformacionGeneral, Reportes, SeguridadSalida } from 'src/app/modelo';
import { environment } from 'src/environments/environment';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-vista-informacion-general',
    templateUrl: './vista-informacion-general.component.html',
    //styleUrls: ['../../../assets/css/css/styles.css', '../../../assets/css/css/bootstrap.css']
})
export class VistaInformacionGeneralComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;
    public url: string;

    //Forma

    public listaVistaInformacionGeneral: OutputVistaInformacionGeneral[];
    public entity: OutputVistaInformacionGeneral;
    public reportes: Reportes = <Reportes>{ InicioObra: false, Habitabilidad: false, Verticalidad: false, AvanceObra: false, EcotecnologiasAtributos: false, SiseviveEcocasa: false };

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.url = environment.url;

    }

    /**
     * 
     */
    public async ngOnInit() {

        setTimeout(() => {
            this.loading();
        }, 500);

    }

    /**
     * 
     */
    public async loading() {

        Util.showLoadingMessage(this.spinner, 'Obteniendo datos ...');

        this.listaVistaInformacionGeneral = [];

        let datos: InputVistaInformacionGeneral = <InputVistaInformacionGeneral>{ idVerificador: this.user.IdEmpresa };

        let resultado: JsonResponse<OutputVistaInformacionGeneral[]> = await this.service.ObtenerVistaInformacionGeneral(datos).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.listaVistaInformacionGeneral = resultado.model;

            if (this.listaVistaInformacionGeneral != null && this.listaVistaInformacionGeneral.length > 0) {
                this.entity = this.listaVistaInformacionGeneral[0];
            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }

        setTimeout(() => {
            Util.hideLoadingMessage();
        }, 1000);

    }

    /**
     * 
     * @param entity
     */
    public onRowSelect(entity: any): void {
        this.reportes = <Reportes>{ InicioObra: false, Habitabilidad: false, Verticalidad: false, AvanceObra: false, EcotecnologiasAtributos: false, SiseviveEcocasa: false };
    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
     * 
     */
    public Continuar(): void {

        let reportes: number = 0;

        if (this.reportes.InicioObra == true) {
            reportes++;
        }

        if (this.reportes.Habitabilidad == true) {
            reportes++;
        }

        if (this.reportes.Verticalidad == true) {
            reportes++;
        }

        if (this.reportes.AvanceObra == true) {
            reportes++;
        }

        if (this.reportes.EcotecnologiasAtributos == true) {
            reportes++;
        }

        if (this.reportes.SiseviveEcocasa == true) {
            reportes++;
        }

        if (reportes > 0) {

            HttpSession.setAttribute('REPORTES', this.reportes);
            HttpSession.setAttribute('ENTITY', this.entity);
            Util.forward(this._router, 'TabsVerificacionComponent');

        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Para continuar debe tener al menos un reporte seleccionado ...', 'warning');
        }

    }

    /**
     * 
     */
    public Salir(): void {
        HttpSession.clear();
        Util.forward(this._router, 'Login');
    }

}

